// Banner
const Listbanner = () => import('@/views/content-management/banner')
const Formbanner = () => import('@/views/content-management/banner/form')
const Orderbanner = () => import('@/views/content-management/banner/order')

export default {
    path: 'banner',
    redirect: '/banner',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'banner',
            component: Listbanner,
            meta: {
                link: 'banner',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Banner', active: true },
                ],
                pageTitle: 'Banner'
            }
        },
        {
            path: 'add',
            name: 'addbanner',
            component: Formbanner,
            meta: {
                link: 'banner',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Banner', url: '/banner' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Banner'
            }
        },
        {
            path: 'edit/:id',
            name: 'editbanner',
            component: Formbanner,
            meta: {
                link: 'banner',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Banner', url: '/banner' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Banner'
            }
        },
        {
            path: 'order',
            name: 'orderbanner',
            component: Orderbanner,
            meta: {
                link: 'banner',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Banner', url: '/banner' },
                    { title: 'Order', active: true },
                ],
                pageTitle: 'Order Banner'
            }
        },
    ]
}